import {TradingAccountReportModel} from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from '../../app/shared/components/report-table';

/** The Hard BP column is left out rather than hidden, because headers and cells align by position. */
export const PanelSettingsGroupsEditAccountsDataTableItems = (withHardBuyingPower: boolean = false): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<boolean>({
            colId: TradingAccountReportModel.getIsCashAccountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getOwnerUserNameSelector(),
            value: null,
            hidden: false
        }),
        ...(withHardBuyingPower ? [new ReportTableData<string>({
            colId: TradingAccountReportModel.getHardBuyingPowerSelector(),
            value: null,
            hidden: false
        })] : []),
    ];
};

export const PanelSettingsGroupsEditAccountsDataTableConfig = (withHardBuyingPower: boolean = false): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingAccountReportModel.getAccountReferenceIdSelector()
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: TradingAccountReportModel.getIsCashAccountSelector()
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: TradingAccountReportModel.getAccountStatusNameSelector()
            }),
            new ReportTableColumn({
                label: 'Client Name',
                selector: TradingAccountReportModel.getOwnerUserNameSelector()
            }),
            ...(withHardBuyingPower ? [new ReportTableColumn({
                label: 'Hard BP',
                selector: TradingAccountReportModel.getHardBuyingPowerSelector()
            })] : []),
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: true,
        hiddenColumnIds: [],
        actionMenu: false
    };
};

